//  ######  #####  ##    ##  ######            #####  ##    ##
//    ##    ##      ##  ##     ##              ##      ##  ##
//    ##    #####    ####      ##    ########  #####    ####
//    ##    ##      ##  ##     ##              ##      ##  ##
//    ##    #####  ##    ##    ##              #####  ##    ##

/*
クリックでテキストを開閉

<div class="js-textExpand--hoge">
  テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
</div>
<button type="button" class="js-textExpand activeToggle" data-target="hoge" data-border-pc="150" data-border-sp="150">
    <div class="is-false activeToggle__off">もっと見る</div>
    <div class="is-false activeToggle__on">閉じる</div>
    <i class="is-false icon-down"></i>
</button>
*/
window.textExpand = function () {
  const textExpand = document.querySelectorAll('.js-textExpand:not(.setup)')
  if (!textExpand[0]) {
    return
  }
  // 高さをチェックし、想定より低い場合は開閉機構を省略する
  for (const expandBtn of textExpand) {
    const target = expandBtn.dataset.target
    expandBtn.classList.add('setup')
    // 表示デバイスに対する基準の高さを取得
    let border = 0
    if (window.matchMedia('(min-width:769px)').matches) {
      border = expandBtn.dataset.borderPc
    } else {
      border = expandBtn.dataset.borderSp
    }

    const expandTarget = document.getElementsByClassName('js-textExpand--' + target)
    for (const iterator of expandTarget) {
      if (iterator.offsetHeight < border) {
        iterator.classList.add('active')
        iterator.classList.add('full')

        // 展開ボタンを消す
        expandBtn.style.display = 'none'
      } else {
        // 高さを制限する
        iterator.style.maxHeight = border + 'px'
        iterator.style.overflow = 'hidden'
      }
    }
  }
}
window.textExpand() // クリックでテキストを開閉

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-textExpand')) {
    return
  }
  const expandBtn = e.target
  const target = expandBtn.dataset.target

  // 表示デバイスに対する基準の高さを取得
  let border = 0
  if (window.matchMedia('(min-width:769px)').matches) {
    border = expandBtn.dataset.borderPc
  } else {
    border = expandBtn.dataset.borderSp
  }

  const expandTarget = document.querySelector('.js-textExpand--' + target)

  if (expandTarget.classList.contains('active')) {
    expandTarget.classList.remove('active')
    expandBtn.classList.remove('active')
    expandTarget.style.maxHeight = border + 'px'
    expandTarget.style.overflow = 'hidden'
  } else {
    expandTarget.classList.add('active')
    expandBtn.classList.add('active')
    expandTarget.style.maxHeight = ''
    expandTarget.style.overflow = ''
  }
})
